module.exports = __webpack_public_path__ + "static/media/breathing.84a1259e.gif";